<div flex-column class="ion-justify-content-between" >
  <app-survey-intervening-form
    #interveningForm
    [intervener]="intervener"
    [survey]="survey"
    (idsToDelete)="handleDelete($event)"
  >
  </app-survey-intervening-form>
  <footer class="ion-padding ion-text-end" max-width *ngIf="!isDisabled">
    <ion-button responsive-button color="buttonPrimary" (click)="submit()">
      {{'COMPONENTS.SAVE_ACTORS' | translate}}
    </ion-button>
  </footer>
</div>

<ng-template #loadingTemplateRef>
  <div class="ion-justify-content-center" ion-padding>
    <ion-spinner color="primary"></ion-spinner>
  </div>
</ng-template>
